import { render, staticRenderFns } from "./BroadcastCompositeFilterChip.vue?vue&type=template&id=081feb6a"
import script from "./BroadcastCompositeFilterChip.vue?vue&type=script&lang=js"
export * from "./BroadcastCompositeFilterChip.vue?vue&type=script&lang=js"
import style0 from "./BroadcastCompositeFilterChip.vue?vue&type=style&index=0&id=081feb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports